import React from 'react';
import { Frame, Navigation } from '@shopify/polaris';
import { useHistory } from 'react-router-dom';

import { HomeMajor, OrdersMajor, SettingsMajor } from '@shopify/polaris-icons';

const AppFrame = (props) => {
    const history = useHistory();

    const navigationMarkup = (
        <Navigation location="/">
            <Navigation.Section
                items={[
                    {
                        label: 'All Orders',
                        icon: HomeMajor,
                        onClick: () => history.push('/')
                    },
                    {
                        label: 'Filtered Orders',
                        icon: OrdersMajor,
                        onClick: () => history.push('/orders-with-image')
                    },
                    {
                        label: 'Settings',
                        icon: SettingsMajor,
                        onClick: () => history.push('/settings')
                    },
                ]}
            />
        </Navigation>
    );

    return (
        <Frame
            navigation={navigationMarkup}
        >
            {props.children}
        </Frame>
    )
}

export default AppFrame;